import { render, staticRenderFns } from "./tag-add-modal.vue?vue&type=template&id=da059300&scoped=true&"
import script from "./tag-add-modal.vue?vue&type=script&lang=js&"
export * from "./tag-add-modal.vue?vue&type=script&lang=js&"
import style0 from "./tag-add-modal.vue?vue&type=style&index=0&id=da059300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da059300",
  null
  
)

export default component.exports